import { TableCell, TableRow, Typography } from '@mui/material'
import React from 'react'
import getLocaleCurrencyForAmount from '../../../../../utils/getLocaleCurrencyForAmount'
import {
  convertTwoDecimalStringToBig,
  formatBigFixedTwoDecimals,
} from '../../../../../utils/bigJSHelper'

type TutorLicensingDetailsRowsProps = {
  subTitle: string
  currencyCode: string
  firstStudentsLabel: string
  additionalStudentsLabel: string
  subTotalLabel: string
  firstStudentsInfo: {
    amount: string
    count: number
    subTotal: string
  }
  additionalStudentsInfo: {
    amount: string
    count: number
    subTotal: string
  }
}

export const TutorLicensingDetailsRows: React.FC<
  TutorLicensingDetailsRowsProps
> = (props) => {
  return (
    <>
      <TableRow>
        <TableCell colSpan={4} sx={{ paddingLeft: 2, fontWeight: 'bold' }}>
          {props.subTitle}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          sx={{
            paddingLeft: 2,
          }}
        >
          {props.firstStudentsLabel}
        </TableCell>
        <TableCell align="right">
          {getLocaleCurrencyForAmount(
            props.firstStudentsInfo.amount,
            props.currencyCode
          )}
        </TableCell>
        <TableCell align="right">{props.firstStudentsInfo.count}</TableCell>
        <TableCell align="right">
          {getLocaleCurrencyForAmount(
            props.firstStudentsInfo.subTotal,
            props.currencyCode
          )}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          sx={{
            paddingLeft: 2,
          }}
        >
          {props.additionalStudentsLabel}
        </TableCell>
        <TableCell align="right">
          {getLocaleCurrencyForAmount(
            props.additionalStudentsInfo.amount,
            props.currencyCode
          )}
        </TableCell>
        <TableCell align="right">
          {props.additionalStudentsInfo.count}
        </TableCell>
        <TableCell align="right">
          {getLocaleCurrencyForAmount(
            props.additionalStudentsInfo.subTotal,
            props.currencyCode
          )}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          sx={{
            paddingLeft: 2,
            fontWeight: 'bold',
          }}
        >
          {props.subTotalLabel}
        </TableCell>
        <TableCell align="right" colSpan={3} sx={{ fontWeight: 'bolder' }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 'bold',
              fontFamily: 'inherit',
              fontSize: '1.3rem',
            }}
          >
            {getLocaleCurrencyForAmount(
              formatBigFixedTwoDecimals(
                convertTwoDecimalStringToBig(
                  props.firstStudentsInfo.subTotal
                ).plus(props.additionalStudentsInfo.subTotal)
              ),
              props.currencyCode
            )}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  )
}
